import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import custom from '@/custom';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import partnerList from '../../partner/partner.List.i18n'
import groupList from '../../group/group.List.i18n'

//restful api
import { signout as manager } from '@/service/api/manager'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'created_at', label: 'Requested_at', sortable: true },
    { key: 'is_del', sortable: true, label:  'Status'},
    { key: 'partner', label: 'Partner' },
    { key: 'group', label: 'Company' },
    { key: 'is_recovery', sortable: true, label: 'Recovery (Continue)'},
    { key: 'is_approve', sortable: true, label: 'Approve (End)' },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'created_at', label: '요청일', sortable: true },
    { key: 'is_del', sortable: true, label: '상태'},
    { key: 'partner', label: '파트너' },
    { key: 'group', label: '회사명' },
    { key: 'is_recovery', sortable: true, label: '복구 (Continue)'},
    { key: 'is_approve', sortable: true, label: '승인 (End)' },
  ]
}

export default {
  components: { DatePicker, vSelect, cSwitch, partnerList, groupList, },
  data: () => ({
    auto_refresh : false,
    model : { total : 0, enable : 0, disable : 0 },
    datepicker,
    loading : false,
    group_name : '',
    chainGroup : false,
    partner_name : '',
    chainPartner : false,
    so : default_opt(),
    custom,
    nbsp : "\u00A0",
    hide_del : false,
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'partner':
          delete this.so.opt.partner_id
          this.partner_name = '';
          this.chainPartner = false;
          break;
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    change_recovery($event) { if($event == true || $event == false) { this.so.opt['is_recovery'] = $event; this.refresh(); } },
    change_done($event) { if($event == true || $event == false) { this.so.opt['is_del'] = $event; this.refresh(); } },
    change_approve($event) { if($event == true || $event == false) { this.so.opt['is_approve'] = $event; this.refresh(); } },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.show_Partner = true;
      this.refresh()
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.show_G = true;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if((k.length > 3 && k.substring(k.length - 3) == "_id") || [].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v == false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    // async remove(n) {
    //   try {        
    //     let rs = await manager.deleteSignout({id : n.id});
    //     if(!rs.error) {
    //       this.$toastr.s('removed.', this.$route.name);
    //     } else {
    //       this.$toastr.s('delete', "failed");
    //     }
    //     this.list(); this.refresh();

    //   } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    // },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { if(!this.loading) { this.$refs._list.refresh(); } },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      this.loading = true
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage,
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }


      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return manager.listSignout(so).then(rs => { this.so.totalRows = rs.total; this.loading = false; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    // accept(user){
    //   user.is_verified = true;
    //   manager.startSignout('user.signout','update.accept', user)
    //     .then(() => { this.$emit('refresh'); this.$toastr.s('Approval'); this.refresh();}).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    // },
    summary() {
      manager.summarySignout({ ts : new Date().getTime() })
        .then(rs => { this.model = Object.assign(this.model, { enable : (rs.body.total - rs.body.disable), disable : rs.body.disable, total : rs.body.total }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    goDetail(item) { this.$router.push(`signout/${item.id}`); },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('signout_List.vue', 'created'); this.$root.$on('selected', this.setPartner); this.$root.$on('select', this.setGroup) },
  destroyed() { console.log('signout_List.vue', 'destroyed'); },
  mounted() {
    console.log('signout_List.vue', 'mounted');
    this.summary();
  },
}